import React from "react";
import { useForm } from "react-final-form";
import { gql } from "@apollo/client";
import { Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import {
  InstrumentTypeSelectField,
  MaterialColorSelectField,
} from "@syos-music/instruments";

import { Grid, FormControlLabel, Checkbox } from "@mui/material";

import SignatureMouthpieceSelectField from "components/signatureMouthpiece/SignatureMouthpieceSelectField";

const SIGNATURE_MOUTHPIECE_FRAGMENT = gql`
  fragment OptionsField_SignatureClarinetMouthpiece on SignatureMouthpiece {
    id
    signature
    mouthpieceColor
    ligatureColor

    mouthpieceRef {
      id
      instrumentType
    }
  }
`;

export default function OptionsField({ name }) {
  const form = useForm();

  const signatureMouthpieceSelectRef = React.useRef();
  const [autoUpdate, setAutoUpdate] = React.useState(false);

  return (
    <Grid container alignItems="flex-start">
      <Grid item xs={12} sm={6}>
        <Field name={`${name}.signature`} component="input" type="hidden" />

        <SignatureMouthpieceSelectField
          filters={{ instrument: ["clarinet"] }}
          name={`${name}.signatureMouthpieceId`}
          required
          ref={signatureMouthpieceSelectRef}
          fragment={SIGNATURE_MOUTHPIECE_FRAGMENT}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={autoUpdate}
              onChange={(evt, checked) => setAutoUpdate(checked)}
            />
          }
          label="Mise à jour auto"
        />

        <OnChange name={`${name}.signatureMouthpieceId`}>
          {() => {
            const { signatureMouthpiece } =
              signatureMouthpieceSelectRef.current;

            form.change(`${name}.signature`, signatureMouthpiece.signature);

            if (!autoUpdate) return;

            form.change(
              `${name}.clarinetType`,
              signatureMouthpiece.mouthpieceRef?.instrumentType
            );
            form.change(
              `${name}.mouthpieceColor`,
              signatureMouthpiece.mouthpieceColor
            );
            form.change(
              `${name}.ligatureColor`,
              signatureMouthpiece.ligatureColor
            );
          }}
        </OnChange>
      </Grid>

      <Grid item xs={12} sm={6}>
        <InstrumentTypeSelectField
          instrument="clarinet"
          name={`${name}.clarinetType`}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField
          name={`${name}.mouthpieceColor`}
          allowPrivate
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField name={`${name}.ligatureColor`} allowPrivate />
      </Grid>
    </Grid>
  );
}
